<template>
  <label class="radio">
    <input
      :id="id"
      class="radio__input"
      :value="id"
      :name="name"
      :checked="checked"
      type="radio"
      @change="$parent.$emit('onInput', $event.target.value)"
    />
    <span class="radio__box" />
    <slot />
  </label>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'InputRadio',

    props: {
      id: {
        type: String as PropType<string>,
        required: true,
      },

      name: {
        type: String as PropType<string>,
        required: true,
      },

      checked: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
    },
  });
</script>

<style lang="scss" scoped>
  .radio {
    display: inline-block;
    font-family: $text-font--1;
    @include normalText;
    padding-left: 34px;
    position: relative;
    cursor: pointer;
    user-select: none;

    @include hover {
      .radio__box {
        border-color: #c722ca;
      }
    }

    &__input {
      appearance: none;
      position: absolute;
      // polyfill
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip: rect(0 0 0 0);
      outline: none;

      &:checked {
        & + .radio__box {
          border-color: #c722ca;

          &:before {
            background-color: #c722ca;
          }
        }
      }
    }

    &__box {
      position: absolute;
      left: 0;
      top: calc(50% - 4px);
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      border: 2px solid #4c4c4c;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 4px;

      &:before {
        content: '';
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: transparent;
      }
    }
  }
</style>
